// extracted by mini-css-extract-plugin
export default {"title":"flORaY","subtitle":"ED1coT","mobile":"iRvir0","sortDropdown":"qqi47i","mobileSearch":"CHea__"};